var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTwitchPlatform = function SvgTwitchPlatform(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 11.1429L15.4286 14.5714H12L9 17.5714V14.5714H5.14286V1.71429H18.8571V11.1429Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28571 0L0 4.28571V19.7143H5.14286V24L9.42857 19.7143H12.8571L20.5714 12V0H4.28571ZM18.8571 11.1429L15.4286 14.5714H12L9 17.5714V14.5714H5.14286V1.71429H18.8571V11.1429Z",
    fill: "#9146FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 4.71429H14.5714V9.85714H16.2857V4.71429Z",
    fill: "#9146FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 4.71429H9.85714V9.85714H11.5714V4.71429Z",
    fill: "#9146FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitchPlatform);
export default ForwardRef;